/*
 * @Autor: hansong27
 * @Email: hansong27@jd.com
 * @Description: 
 * @CreateDate: Do not edit
 * @LastEditors: hansong27
 */
import { createStore, applyMiddleware } from "redux";
import reducer from './reducer'
import { composeWithDevTools } from "@redux-devtools/extension";
import createSagaMiddleware from "redux-saga";
const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware))
);

// sagaMiddleware.run(mainSaga);

// const store = createStore(reducer)

export default store
